module.exports = __webpack_public_path__ + "static/hero-infinity-2510be2dc352d3e468574b4c130a0f91.svg";